import type { ComponentType } from "react";
import type { Review } from "@/modules/review/types";
import type { Brand, BrandKit } from "@/modules/brand/types";
import type { SchemaField } from "../types";
import DefaultTemplate from "./default-template";

// Shared props interface for all template components
export interface TemplateProps {
	currentBrand: Brand;
	reviews: Review[];
	brandKit: BrandKit;
	contentConfig?: Record<string, unknown>;
	layoutConfig?: Record<string, unknown>;
	contentSchema?: Record<string, SchemaField>;
	onContentConfigChange: (key: string, value: unknown) => void;
	isLoading?: boolean;
	nextCursor?: string | null;
	onLoadMore?: () => Promise<void>;
	isLoadingMoreReviews?: boolean;
	resourceOptions?: Record<string, Array<{ value: string; label: string }>>;
}

// Map of template names to their components
// Add new templates here as they are created
const TEMPLATE_COMPONENTS: Record<string, ComponentType<TemplateProps>> = {
	default: DefaultTemplate,
};

interface TemplateRouterProps extends TemplateProps {
	template: string;
}

export default function TemplateRouter({ template, ...props }: TemplateRouterProps) {
	const TemplateComponent = TEMPLATE_COMPONENTS[template];

	// Fallback to default template if the specified template doesn't exist
	if (!TemplateComponent) {
		if (import.meta.env.DEV) {
			console.warn(`Template "${template}" not found, falling back to default template`);
		}
		return <DefaultTemplate {...props} />;
	}

	return <TemplateComponent {...props} />;
}
